<template>
  <header :class="`${ns}`" v-if="disabled !== true">
    <a :class="`${ns}__settings-button`" href="">Settings</a>
  </header>
</template>

<script>
  export default {
    name: 'GlobalToolbar',
    props: {
      disabled: {
        default: false,
        type: Boolean
      }
    },
    data () {
      return {
        ns: 'global-toolbar'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/GlobalToolbar.vue